import { Reveal } from "@/components/Reveal";
import { Overline } from "@/components/primitives";
import { WHERE_GROUPS, EDITORIAL_DISCLAIMER, INDUSTRIES } from "@/data/content";

export default function WhereAuthority({ withHeader = true }) {
  return (
    <section className="py-24 md:py-36 bg-mist/50 border-b hairline" data-testid="where-authority-section">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        {withHeader && (
          <div className="max-w-3xl mb-16">
            <Reveal><Overline>05 — The Landscape</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-heading font-light text-navy tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                Where authority is built.
              </h2>
            </Reveal>
          </div>
        )}

        {/* Four categories */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t hairline" data-testid="where-groups-grid">
          {WHERE_GROUPS.map((g, i) => (
            <Reveal key={g.title} delay={i * 0.06} className="border-r border-b hairline">
              <div className="h-full bg-warm px-7 py-9">
                <span className="font-heading text-gold text-xs tracking-widest">0{i + 1}</span>
                <h3 className="mt-3 font-heading font-light text-navy text-2xl md:text-[1.75rem] leading-tight">{g.title}</h3>
                <ul className="mt-6 space-y-2.5">
                  {g.items.map((it) => (
                    <li key={it} className="text-sm text-ink/60 font-body flex items-center gap-3">
                      <span className="w-1 h-1 rounded-full bg-navy/30" />{it}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Industry ecosystems */}
        <div className="mt-20">
          <Reveal><p className="overline text-navy/50 mb-8">Industry Ecosystems</p></Reveal>
          <div className="flex flex-wrap gap-3" data-testid="industry-tags">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind} delay={i * 0.02}>
                <span className="inline-block border border-navy/20 px-5 py-3 text-sm text-navy/80 hover:border-gold hover:text-navy transition-colors duration-300 font-body">
                  {ind}
                </span>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.1}>
          <p className="mt-14 max-w-4xl text-xs leading-relaxed text-ink/45 font-body" data-testid="editorial-disclaimer">
            {EDITORIAL_DISCLAIMER}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
